const ACTION_SCOPE = '[Applications Filter]';

export class LoadApplicationsFilterOptions {
    static readonly type = `${ACTION_SCOPE} Load Options`;
    constructor(public payload: { seasonId: string }) {}
}

export class ResetApplicationsFilterOptions {
    static readonly type = `${ACTION_SCOPE} Reset Options`;
}
